import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import borderMixin from '../../../styles/utils/borderMixin';
import { p4Tokens } from '../../../styles/themes/default/p4FluentTheme';

const StyledInput = styled.input<React.CSSProperties>`
  display: inline-block;
  width: 100%;
  padding: ${(props) => props.padding || props.style?.padding || '0 4px 0 0'};
  font-size: 14px;
  font-weight: 400;
  color: ${p4Tokens.colorNeutralForeground1};
  background-color: ${p4Tokens.colorNeutralBackground1};
  background-image: none;
  vertical-align: middle;
  text-align: ${(props) => (props.textAlign === 'right' || props.datatype === 'numeric' ? 'right' : 'left')};
  ${borderMixin} &:disabled {
    cursor: not-allowed;
  }
`;

const Input = forwardRef<any, any>(
  (
    {
      id,
      decimals,
      disabled,
      testId,
      type,
      value,
      spellCheck,
      onChangeValue,
      onCommit,
      onCommitCancel,
      onOverrideKeyDown,
      onRowClick,
      ...rest
    }: any,
    ref
  ) => {
    //Note: 'onWhatever' is included here to strip them from '...rest' that will be passed to the Styled Component.

    let val = value ?? '';
    if (decimals !== null && decimals !== undefined && typeof value === 'number') {
      val = value.toFixed(decimals);
    }
    let ids = {};
    if (id) ids = { id, key: id, 'data-testid': testId };

    if (type === 'hide') {
      return <span>{'*'.repeat(val.length)}</span>;
    }

    return (
      <StyledInput
        ref={ref}
        autoComplete="off"
        disabled={disabled}
        type={type || 'text'}
        value={val}
        spellCheck={spellCheck}
        {...ids}
        {...rest}
      />
    );
  }
);

Input.propTypes = {
  disabled: PropTypes.bool,
  handleChange: PropTypes.func,
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};
Input.defaultProps = {
  disabled: false,
  handleChange: () => {},
  id: '',
  testId: '',
  type: 'text',
};

export default Input;
